<template>
  <article id="error-article">
    <div class="error">
      <p>{{ text }}</p>
      <a :href="href">{{ linkText }}</a>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    error: {
      type: String,
      default: '',
    },
  },
  computed: {
    text() {
      return this.$t(`errors.${this.error}.text`);
    },
    href() {
      return this.$t(`errors.${this.error}.href`);
    },
    linkText() {
      return this.$t(`errors.${this.error}.linkText`);
    },
  },
};
</script>

<style lang="scss" scoped src="./Error.scss"></style>
